<template>
  <el-cascader
      ref="cascader"
      v-model="defaultValue"
      :options="options"
      :props="props"
      :change-on-select="changeOnSelect"
      style="width: 100%"/>
</template>

<script>
  const moduleName = "districts/getOtherDistrictList";
  const storage = window.localStorage;

  export default {
    props: {
      value: {
        type: Number,
        default: 0,
      },
      changeOnSelect: Boolean,
    },
    data() {
      return {
        options: [],
        defaultValue: [],
        props: {
          label: "districtName",
          value: "districtID",
        },
      };
    },
    watch: {
      value: function(val) {
        console.log(val);
        if (val === 0) {
          this.defaultValue = [];
          return;
        }
        if (val === this.defaultValue[this.defaultValue.length - 1]) {
          return;
        }
        this.$http
          .get("basic", `districts/cascade/${val}`)
          .then(resp => {
            this.defaultValue = resp;
            console.log(this.defaultValue);
          }).catch(() => {
            this.$message.error("获取省市区数据失败");
          });
      },
      defaultValue: function(val) {
        let id = val[val.length - 1];
        if (id) {
          this.$emit("input", id);
          let labels = this.currentLabels();
          this.$emit("onChange", val, labels);
        }
      },
    },
    mounted() {
      this.getDistricts();
    },
    methods: {
      getDistricts() {
        let data = storage.getItem("ems_" + moduleName);
        if (data) {
          this.options = JSON.parse(data);
          console.log(this.options);
        } else {
          this.$http
            .get("basic", "districts/getOtherDistrictList")
            .then(resp => {
              console.log(resp);
              this.options = resp;
              // storage.setItem("ems_" + moduleName, JSON.stringify(resp));
            }).catch(error => {
              this.$message.error("获取省市区数据失败，" + error.response.data.message);
            });
        }
      },
      currentLabels() {
        let options = this.options;
        let labels = [];
        this.defaultValue.forEach(value => {
          const targetOption = options && options.filter(option => option.id === value)[0];
          if (targetOption) {
            labels.push(targetOption.name);
            options = targetOption.children;
          }
        });
        return labels;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
